export default __webpack_public_path__ + "static/media/mo.58d474f3.svg";